import { HospitalCtx } from '@components/hospital';
import Iconify from '@components/iconify';
import Image from '@components/image/Image';
import { BoxProps, IconButton, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useResponsive from '@proccess/hooks/useResponsive';
import { map } from 'lodash';
import Router from 'next/router';
import { forwardRef, useState } from 'react';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  openNav?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, openNav, ...other }, ref) => {
    useTheme();

    const isDesktop = useResponsive('up', 'lg');

    const { hospital, hospitals, fncs } = HospitalCtx.useCtx();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const logo = (
      <Stack
        ref={ref}
        direction={!openNav || !isDesktop ? 'row' : 'column'}
        alignItems={'center'}
        gap={1}
        onClick={() => {
          Router.push('/');
        }}
        {...other}
      >
        <Image
          disabledEffect
          src={String(hospital?.logo_image_url)}
          alt="logo"
          style={{ width: 50, height: 50, objectFit: 'scale-down' }}
        />
        {(!openNav || !isDesktop) && (
          <Typography fontSize={16} fontWeight={600}>
            {hospital?.name}
          </Typography>
        )}
        <Tooltip title="Chọn bệnh viện">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleClick(e);
            }}
            size="small"
            sx={{ height: 'fit-content', backgroundColor: 'background.neutral' }}
            color="primary"
          >
            <Iconify icon="eva:arrow-ios-downward-fill" width={16} height={16} />
          </IconButton>
        </Tooltip>
      </Stack>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <>
        <Stack sx={{ display: 'contents' }}>{logo}</Stack>

        <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
          {map(hospitals, (item) => {
            const isSelected = hospital?.id === item?.id;
            return (
              <MenuItem
                selected={isSelected}
                key={item?.id}
                onClick={async () => {
                  handleClose();
                  fncs.onGetHospitalDetails({ id: item?.id });
                  Router.push('/');
                }}
              >
                {item?.name}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }
);

export default Logo;
